import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'Nue-propriété de SCPI' })(HeaderInner);

export default Header;
